import React, { Component } from 'react'
import './index.less'
interface CourierInfoProps {
    name: string
    onClick?: () => void
}

export default class CourierInfo extends Component<CourierInfoProps> {
    render() {
        return (
            <div className='courier-content' onClick={this.props.onClick}>
                <span className='courier-title'>配送员</span>
                <div className='courier-brief'>
                    <img className='courier-tel-icon' src='/public/assets/img/order_detail_telephone.png' alt="" />
                    <span className='courier-tel'>联系配送员</span>
                    <span className='courier-name'>{this.props.name}</span>
                </div>
            </div>
        )
    }
}